import { render, staticRenderFns } from "./SetupIssues.vue?vue&type=template&id=8a91c1a6&scoped=true"
import script from "./SetupIssues.vue?vue&type=script&lang=js"
export * from "./SetupIssues.vue?vue&type=script&lang=js"
import style0 from "./SetupIssues.vue?vue&type=style&index=0&id=8a91c1a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a91c1a6",
  null
  
)

export default component.exports